import Vue from 'vue'
import { mapMutations, mapState } from 'vuex'
import BigNumber from 'bignumber.js'
import { TIME_FIXED } from '@/constants/backend/service'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import snackMixin from '@/mixins/snackMixin'
import { RootState } from '@/store'
import { formatUsd } from '@/utils/moneyFormat'
import { gigJobPartiesMixin, offerManageMixin, statusesMixin } from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [gigJobPartiesMixin, offerManageMixin, snackMixin, statusesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
    }),
    appOffer() {
      return this.application.offer
    },
    isTimeFixed() {
      return this.appOffer?.timeType === TIME_FIXED
    },
    isNewOffer() {
      return this.appOffer?.stage === GigOfferStages.NEW
    },
    deadline() {
      if (this.isTimeFixed) {
        return `${this.appOffer?.deadlineInDays} days delivery`
      }
      const hour = this.appOffer?.timeValue === 1 ? 'hour' : 'hours'
      return `${this.appOffer?.timeValue} ${hour} delivery`
    },
    budget() {
      let total = new BigNumber(this.appOffer?.budget)
      if (!this.isTimeFixed) {
        total = total.multipliedBy(this.appOffer?.timeValue)
      }
      return formatUsd(total)
    },
    hasActions() {
      return this.appOffer?.stage === GigOfferStages.NEW
    },
  },
  methods: {
    onCancelOfferClick() {
      this.cancelOffer()
    },
    onEditOfferClick() {
      this.editOffer()
    },
    async onAcceptClick() {
      this.acceptOffer()
    },
  },
})
